import { render, staticRenderFns } from "./multiple-service.vue?vue&type=template&id=2d6efa12&scoped=true&"
import script from "./multiple-service.vue?vue&type=script&lang=js&"
export * from "./multiple-service.vue?vue&type=script&lang=js&"
import style0 from "./multiple-service.vue?vue&type=style&index=0&id=2d6efa12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6efa12",
  null
  
)

export default component.exports